module.exports = __webpack_public_path__ + "img/popup-bg-2.4ad7eb3.png";